import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ReactInputMask from "react-input-mask";
import { isMobile } from "react-device-detect";

import "./contact-us.scss";
import SelectField from "../../components/select/select";

const schema = yup
  .object({
    assunto: yup.string().required("Escolha um(a) assunto!"),
    nome: yup.string().required("Nome é uma informação obrigatória!"),
    email: yup
      .string()
      .required("Email é uma informação obrigatória!")
      .email("Email não está em um formato válido!"),
    telefone: yup
      .string()
      .required("O telefone é obrigatório!")
      .matches(/\(\d{2}\)\s\d{5}-\d{4}/, "Formato de telefone inválido!"),
    mensagem: yup.string().required("Mensagem é uma informação obrigatória!"),
  })
  .required();

const assuntOptions = [
  { label: "Dúvida", value: "duvida" },
  { label: "Sugestão", value: "sugestão" },
  { label: "Reclamação", value: "reclamação" },
  { label: "Elogio", value: "elogio" },
];

function ContactUs() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <div className="contact-us">
      <div className="container-fluid">
        <div className="container">
          <div
            className={`d-flex align-items-center text-center title-content ${
              isMobile ? "flex-column gap-0" : "gap-3"
            }`}
          >
            <h1>Contato</h1>
            <div
              className="diviser"
              style={isMobile ? { display: "none" } : { display: "block" }}
            ></div>
            <h2>
              Envie uma mensagem para nós, entraremos em contato o mais breve
              possível.
            </h2>
          </div>
          <div className="py-4 d-flex justify-content-center form-container">
            <form onSubmit={handleSubmit(onSubmit)} className="w-100 form">
              <div className="mb-4">
                <label className="form-label">Assunto</label>
                <SelectField
                  label={"Selecione o assunto desejado"}
                  options={assuntOptions}
                  defaultValue={""}
                  register={register}
                  name={"assunto"}
                  padding={"18px 24px"}
                />
                {errors.assunto ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.assunto.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-4">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-control"
                  id="nomeInput"
                  placeholder="Seu nome completo"
                  {...register("nome")}
                />
                {errors.nome ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.nome.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-4">
                <label className="form-label">Telefone</label>
                <ReactInputMask
                  className="form-control"
                  mask="(99) 99999-9999"
                  placeholder="DDD + Celular"
                  maskChar={null}
                  {...register("telefone")}
                >
                  {(inputProps) => <input {...inputProps} />}
                </ReactInputMask>
                {errors.telefone ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.telefone.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-4">
                <label className="form-label">E-mail</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Seu principal e-mail"
                  {...register("email")}
                />
                {errors.email ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.email.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-4">
                <label className="form-label">Mensagem</label>
                <textarea
                  id="msgTextArea"
                  className="form-control form-textarea"
                  aria-label="With textarea"
                  placeholder="Deixe sua mensagem"
                  {...register("mensagem")}
                ></textarea>
                {errors.mensagem ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.mensagem.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="text-center">
                <button type="submit" className="btn button-control">
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
